module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_location_photowedding-166c360494aa95228c4883fcbaf51536.webp";